// angular
import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { AppService } from '../../app.service';
import { CoreService } from '../../core/core.service';
import { KlenicoMeService } from '../me.service';
import { TranslateService } from '@ngx-translate/core';
import { MeAppointmentService } from './appointment.service';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';


@Component({
    selector: 'me-appointment',
    templateUrl: './appointment.component.html',
    styleUrls: ['./appointment.component.scss'],
    providers: [MeAppointmentService]
})

export class MeAppointmentComponent implements OnInit,AfterViewInit, OnDestroy {
    isSelectTherapist = true;
    therapists = [];
    cituroTherapist = [];
    language = 0;
    languages = [];
    subcription: Subscription;


    constructor(
        public appService: AppService,
        public coreService: CoreService,
        public meService: KlenicoMeService,
        public translate: TranslateService,
        public router: Router,
        public meAppointmentService: MeAppointmentService
    ) {
       
    }

    ngOnInit() {
        this.appService.isLoading = true;
        this.languages = _.cloneDeep(this.appService.meLanguages);

        this.languages.unshift({
            'id' : 0,
            'name' : 'All languages'
        });

        this.subcription = this.translate.onLangChange.subscribe(value => {
            this.languages.forEach(language => {
                if (value.lang === language.locale) {
                    this.language = language.id;
                }
            })
            this.getTherapistData();
        });

        this.getTherapists();
    }

    ngAfterViewInit() {
        this.coreService.className = 'me-landing-page';
        this.meService.isNonMedicalFooter = true;
    }

    ngOnDestroy() {
        this.subcription.unsubscribe();
    }

    getTherapists() {
        this.meAppointmentService.getTherapists().subscribe(res => {
            this.cituroTherapist = res['therapists'];
            this.language = res['patient_lang'];
            this.getTherapistData();
            this.appService.isLoading = false;
        });
    }

    getTherapistData() {
        this.therapists = [];
        this.cituroTherapist.forEach(therapist => {
            this.meAppointmentService.getTherapistStoryBlok(therapist['id']).subscribe(response => {
                if (response['stories'] && response['stories'].length > 0) {
                    let content = response['stories'][0]['content'];
                    therapist['title'] = content['title'];
                    therapist['image'] = content['image'];
                    therapist['text'] = content['text'];
                    therapist['hide'] = false;
                    this.therapists.push(therapist);
                }
            });
        });
    }

    viewCalendar(id) {
        this.router.navigate(['me/appointment/booking', id]);
    }
}
